import {
  House,
  type LucideIcon,
  Megaphone,
  MessageSquare,
  Network,
  Target,
  Users,
} from 'lucide-react';
import { de } from '@/i18n/de';

export type NavItem = { id: string; href: string; label: string; Icon: LucideIcon };

const heute: NavItem = { id: 'heute', href: '/', label: de.nav.heute, Icon: House };
const nachrichten: NavItem = {
  id: 'nachrichten',
  href: '/nachrichten',
  label: de.nav.nachrichten,
  Icon: MessageSquare,
};
const menschen: NavItem = {
  id: 'menschen',
  href: '/menschen',
  label: de.nav.menschen,
  Icon: Users,
};
const netzwerk: NavItem = {
  id: 'netzwerk',
  href: '/netzwerk',
  label: de.nav.netzwerk,
  Icon: Network,
};
const zielpersonen: NavItem = {
  id: 'zielpersonen',
  href: '/zielpersonen',
  label: de.nav.zielpersonen,
  Icon: Target,
};
const sichtbarkeit: NavItem = {
  id: 'sichtbarkeit',
  href: '/sichtbarkeit',
  label: de.nav.sichtbarkeit,
  Icon: Megaphone,
};

/** Hauptziele der oberen Leiste (Desktop und Tablet). */
export const MAIN_NAV: readonly NavItem[] = [
  heute,
  nachrichten,
  menschen,
  netzwerk,
  zielpersonen,
  sichtbarkeit,
];

/** Hauptziele der unteren Leiste (Handy): vier plus „Mehr“. */
export const MOBILE_NAV: readonly NavItem[] = [heute, nachrichten, menschen, sichtbarkeit];

const more = (id: string, href: string, label: string): Omit<NavItem, 'Icon'> => ({
  id,
  href,
  label,
});

/** Übrige Ziele im Menü „Mehr“ (ohne Symbol: Menüeinträge tragen Wort statt Symbol). */
const MORE_COMMON = [
  more('zielgruppen', '/zielgruppen', de.nav.zielgruppen),
  more('zielpersonenFinden', '/neue-zielpersonen', de.nav.zielpersonenFinden),
  more('ziele', '/ziele', de.nav.ziele),
  more('ablaeufe', '/ablaeufe', de.nav.ablaeufe),
  more('einwilligung', '/einwilligung', de.nav.einwilligung),
  more('konto', '/konto', de.nav.konto),
  more('einstellungen', '/einstellungen', de.nav.einstellungen),
  more('datenschutz', '/datenschutz', de.nav.datenschutz),
  more('verbindungen', '/verbindungen', de.nav.verbindungen),
] as const;

export type MoreItem = Omit<NavItem, 'Icon'>;

/** „Mehr“ am Desktop und Tablet. */
export const MORE_NAV: readonly MoreItem[] = MORE_COMMON;

/** „Mehr“ auf dem Handy: zusätzlich die Ziele, die in der unteren Leiste keinen Platz haben. */
export const MOBILE_MORE_NAV: readonly MoreItem[] = [
  more('netzwerk', '/netzwerk', de.nav.netzwerk),
  more('zielpersonen', '/zielpersonen', de.nav.zielpersonen),
  ...MORE_COMMON,
];

/** Aktiv ist ein Ziel auf seiner Seite und auf allen Unterseiten; „Heute“ nur auf der Startseite. */
export function isActive(pathname: string, href: string): boolean {
  if (href === '/') {
    return pathname === '/';
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}
